<div class="loading-overlay" [class.loading-overlay--shown]="isSaving()">
  <fmnts-loading-indicator size="sm" variant="fontawesome" />

  <br />

  @if (isSaving()) {
    <div class="loading-overlay__text">
      <p>{{ 'uploading' | translate }}</p>
    </div>
  }
</div>

@if (donorFeedback) {
  <div class="header" [class.header--with-image]="donorFeedback.headerImage">
    @if (donorFeedback.headerImage) {
      <img
        class="header__img"
        src="{{ donorFeedback.headerImage | translateInline }}"
        alt=""
      />
    }

    <div class="header__logo">
      @if (donorFeedback.organizationLogo) {
        <img
          class="header__organization-img"
          src="{{ donorFeedback.organizationLogo }}"
          alt=""
        />
      }
    </div>
  </div>

  <div class="flex flex-col items-center pt-12">
    @if (donorFeedback.fundraiserImage) {
      <img class="fundraiser__img" src="{{ donorFeedback.fundraiserImage }}" />
    }
    <p class="fundraiser__firstName">{{ donorFeedback.fundraiserName }}</p>
    @if (donorFeedback.fundraiserRole) {
      <p class="fundraiser__role">
        {{ donorFeedback.fundraiserRole }}
      </p>
    }
  </div>

  <supporter-feedback-form-page
    [page]="donorFeedback.form"
    [pages]="[donorFeedback.form]"
    [style]="donorFeedback.style"
    [validationStrategy]="validationStrategy"
    (action)="handleAction($event)"
    class="form"
  />
}
